<template>
  <Transition name="dialog">
    <div
      v-if="show"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-6"
      @click.self="handleClose"
    >
      <div
        class="bg-white rounded-3xl p-6 max-w-sm w-full shadow-xl"
        @click.stop
      >
        <h3 class="font-bold text-lg text-textMain mb-6 text-center">
          日曆已標記
        </h3>

        <div class="space-y-3">
          <button
            @click="handleReopen"
            class="w-full bg-primary text-white font-bold py-3 rounded-xl active:scale-[0.98] transition-transform"
          >
            重新打開日曆
          </button>

          <button
            @click="handleUnmark"
            class="w-full bg-white text-textMain font-bold py-3 rounded-xl border-2 border-gray-200 active:scale-[0.98] transition-transform"
          >
            取消標記
          </button>

          <button
            @click="handleClose"
            class="w-full text-textMuted font-bold py-3 active:opacity-60 transition-opacity"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  close: []
  reopen: []
  unmark: []
}>()

const handleClose = () => {
  emit('close')
}

const handleReopen = () => {
  emit('reopen')
  emit('close')
}

const handleUnmark = () => {
  emit('unmark')
  emit('close')
}
</script>

<style scoped>
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .bg-white,
.dialog-leave-active .bg-white {
  transition: transform 0.3s ease;
}

.dialog-enter-from .bg-white,
.dialog-leave-to .bg-white {
  transform: scale(0.95);
}
</style>
